import { getCleanEstilo, getStoredFeatureOverrides, parseFeaturesFromBusiness } from './businessConfigHelpers';
import { getDemoServicesForBusiness } from './demoData';

export const DEMO_BUSINESS_IDS = ['9001', '9002', '9003'];

// Un negocio tal como lo usa la app: los módulos y ajustes guardados en `estilo` (__FEATURES__) y los cambios locales encima,
// y listas vacías (o los servicios de ejemplo si es una demo) en lugar de nulos. Lo usan el arranque con sesión y el ingreso a las demos.
export const normalizeBusiness = (b, overrides = getStoredFeatureOverrides()) => {
  const bOverrides = overrides[String(b.id)] || overrides[b.id] || {};
  const featuresFromEstilo = parseFeaturesFromBusiness(b);
  const rawServices = Array.isArray(b.services) ? b.services : [];
  const isDemo = DEMO_BUSINESS_IDS.includes(String(b.id));
  const finalServices = rawServices.length > 0 ? rawServices : (isDemo ? getDemoServicesForBusiness(b.id) : []);

  return {
    ...b,
    estilo_clean: getCleanEstilo(b.estilo),
    ...featuresFromEstilo,
    ...bOverrides,
    // Lo que decide si el bot responde vive en la base de datos (n8n la lee); la copia local del
    // navegador no puede contradecirla, o la pantalla dice "encendido" con el bot apagado.
    bot_activo: featuresFromEstilo.bot_activo,
    whatsapp_enabled: featuresFromEstilo.whatsapp_enabled,
    services: finalServices,
    staff: Array.isArray(b.staff) ? b.staff : [],
    appointments: Array.isArray(b.appointments) ? b.appointments : [],
    orders: Array.isArray(b.orders) ? b.orders : []
  };
};

const DEMO_TYPES = { barberia: 'Barbería', restaurante: 'Restaurante', clinica: 'Clínica' };

// Si la base no deja leer la demo sin sesión, se arma una con los módulos que anuncia la propia cuenta demo.
export const demoFallbackBusiness = (demo) => {
  const id = String(demo.legacyIds?.[0] || demo.id);
  const features = Object.fromEntries((demo.features || []).map((key) => [key, true]));
  return { id, nombre_negocio: demo.name, tipo_negocio: DEMO_TYPES[demo.type] || demo.type, slug: demo.slug, activo: true, ...features };
};
